export const ONE_TRUST_ANALYTICS_COOKIE_GROUP_ID = 'C0003';
